import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    partnerIds: Array<string>;
    phone: string | null;
};

export const schemaPartnerResolver_HasReachablePartnerAdvisor = z.boolean();

export type SchemaPartnerResolver_HasReachablePartnerAdvisor = z.infer<
    typeof schemaPartnerResolver_HasReachablePartnerAdvisor
>;
export type PartnerResolver_HasReachablePartnerAdvisor = Resolver<
    Arguments,
    SchemaPartnerResolver_HasReachablePartnerAdvisor
>;
